/**
 * Created by Karol Kluska on 11.01.18.
 */

angular
  .module('app')
  .directive('fixedElement', fixedElement);

function fixedElement(parentIframeData, $interval) {
  return {
    restrict: 'AE',
    controller: 'parentIframeWatcherController',
    link: function (scope, elem) {
      var settable = true;
      var parentData = {};

      $interval(function () {
        parentData.enable = parentIframeData.enable;
        parentData.scrollTop = parentIframeData.scrollTop;
        parentData.offsetTop = parentIframeData.offsetTop;
      }, 100);

      scope.$watch(function () {
        return parentData;
      }, function (data) {
        if (data.enable && settable) {
          changeElementPosition(elem, data.scrollTop, data.offsetTop);
          settable = false;
        }
      }, true);

      function changeElementPosition(elem, scrollTop, offsetTop) {
        elem.closest('.modal-content').css({
          position: 'absolute',
          top: (scrollTop - offsetTop < 0) ? 0 : scrollTop - offsetTop,
          left: 0,
          width: 100 + '%'
        });
        elem.closest('.uib-datepicker-popup-wrapper').css({
          position: 'absolute',
          top: (scrollTop - offsetTop < 0) ? 0 : scrollTop - offsetTop,
          left: 0,
          width: 100 + '%',
          height: 300 + 'px'
        });
      }
    }
  };
}
